import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const feedbackApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/feedback",
      params,
    }),
  findOne: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/feedback/${id}`,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/feedback",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/feedback/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/feedback/${id}`,
      method: "delete",
    }),
};
